import { insertMentionNode } from '#pplx/frontend/apps/ask/ask-input/ask-input-mentions/insertMentionNode.js';
import { PLUGIN_ICON } from '#pplx/frontend/apps/ask/skills/utils/getMenuIcon.js';
import { getPluginMentionURL } from '#pplx/frontend/apps/ask/skills/utils/getPluginMentionURL.js';
export function insertPluginMentionNode(editor, plugin, options = {}) {
    insertMentionNode(editor, {
        variant: 'plugin',
        text: plugin.name,
        localizedName: plugin.displayName || undefined,
        ...(options.prefixWithSlash === undefined
            ? {}
            : { prefixWithSlash: options.prefixWithSlash }),
        uuid: plugin.id,
        url: getPluginMentionURL(plugin.id),
        icon: { type: 'icon', icon: PLUGIN_ICON },
    }, options);
}
//# sourceMappingURL=insertPluginMentionNode.js.map